/* istanbul ignore file */
import PropTypes from 'prop-types';

export const localeDataPropTypes = PropTypes.shape({
  loadedLanguage: PropTypes.shape({
    code: PropTypes.string,
  }),
});

export const addressPropTypes = PropTypes.shape({
  city: PropTypes.string,
  postcode: PropTypes.string,
  district: PropTypes.string,
  state: PropTypes.string,
  address_1: PropTypes.string,
  address_2: PropTypes.string,
  country: PropTypes.string,
  logistic_codes: PropTypes.arrayOf(PropTypes.string),
});

export const marketingConsentPropTypes = PropTypes.shape({
  created_at: PropTypes.string,
  facebook: PropTypes.bool,
  line: PropTypes.bool,
  sms: PropTypes.bool,
  updated_at: PropTypes.string,
  whatsapp: PropTypes.bool,
  _id: PropTypes.string,
});

export const userPropTypes = PropTypes.shape({
  birth_day: PropTypes.number,
  birth_month: PropTypes.number,
  birth_year: PropTypes.number,
  bound_facebook_accounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      message_center_link: PropTypes.string,
      name: PropTypes.string,
      platform_channel_name: PropTypes.string,
      platform_user_id: PropTypes.string,
      profile_pic_url: PropTypes.string,
    }),
  ),
  credit_balance: PropTypes.number,
  country_calling_code: PropTypes.string,
  created_at: PropTypes.string,
  created_by: PropTypes.string,
  created_by_channel: PropTypes.string,
  delivery_addresses: PropTypes.arrayOf(
    PropTypes.shape({
      ...addressPropTypes,
      recipient_name: PropTypes.string,
      recipient_phone: PropTypes.string,
      recipient_phone_country_code: PropTypes.string,
    }),
  ),
  email: PropTypes.string,
  exclude_sms_platform: PropTypes.bool,
  info_reward_claimed: PropTypes.bool,
  is_email_confirmed: PropTypes.bool,
  is_member: PropTypes.bool,
  is_mobile_phone_confirmed: PropTypes.bool,
  is_password_set: PropTypes.bool,
  is_quick_signup: PropTypes.bool,
  locale_code: PropTypes.string,
  marketing_consent: marketingConsentPropTypes,
  member_point_balance: PropTypes.number,
  mobile_phone: PropTypes.string,
  mobile_phone_confirmed_at: PropTypes.string,
  name: PropTypes.string.isRequired,
  owner_id: PropTypes.string,
  owner_type: PropTypes.string,
  phone: PropTypes.string,
  phone_country_code: PropTypes.string,
  registered_by: PropTypes.string,
  status: PropTypes.string,
  _id: PropTypes.string.isRequired,
});
